import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
// import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
// import { faCopy } from '@fortaweTsome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
import { Checkbox } from '@mui/material';




function AuthenticationCheck() {

    const { loginStore } = useStore();
    const { UserProfileStore } = useStore();


    const useStyles = makeStyles((theme) => ({
        //Dialog
        Dialog: {
            width: 'auto',
            height: "400px",
        },
        DialogMobile: {
            height: 'auto',
            width: '100%',
            minWidth: "320px",
        },
        //blackWallet
        blackWalletImage: {
            width: '108%',
            marginRight: '-265px'

        },
        blackWalletImageMobile: {
            width: '90%',
            marginRight: '-265px'
        },
    }));




    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");
    const isAuthenticationDialogOpen = loginStore?.isAuthenticationDialogOpen;
    const VerifyShareBool = UserProfileStore?.VerifyShareBool;
    // this.VerifyShareBool = false;
    // console.log("APageIN", isAuthenticationDialogOpen);


    let Guide_clover_allPage_04 = loginStore?.Guide_clover_allPage_04; //개인정보 수집 이용 동의
    let Guide_clover_dialog_AuthenticationCheck_01 = loginStore?.Guide_clover_dialog_AuthenticationCheck_01; //My.동의
    let Guide_clover_dialog_AuthenticationCheck_02 = loginStore?.Guide_clover_dialog_AuthenticationCheck_02; //본인 인증 내용

    const testText = "본인 인증을 위한 개인정보 수집 · 이용 및 제공, 위탁 동의서 \n 개인정보 보호법에 따라 (주)SoftBrain에 인증을 요청하시는 분께 \n 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간, 동의 거부권 및 동의 거부 시 \n 불이익에 관한 사항을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다. \n 1. 개인정보의 수집 및 이용목적 \n 서비스 이용시 이용자로부터 수집하는 개인정보는 아래와 같습니다. \n -회원정보 또는 개별 서비스에서 프로필 정보 ( 닉네임, 프로필 사진 )를 설정할 수 있습니다. \n 2. 수집하려는 개인정보의 항목 \n -인증 요청 시에 '휴대전화번호,이메일 주소'를 필수항목으로 수집합니다. \n 3.개인정보의 보유 및 이용기간 \n - 부정 가입 및 이용 방지 \n 탈퇴한 이용자의 휴대전화번호 : 탈퇴일로부터 6개월 보관 \n 4. 개인정보 수집 및 이용 동의를 거부할 권리 \n 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. \n 회원가입 시 수집하는 최소한의 개인정보, 즉, 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우, 인증 요청이 어려울 수 있습니다"





    const WhiteTextTypography = withStyles({
        root: {
            color: "#FFFFFF",
            fontSize: "1.5rem"

        }
    })(Typography);





    return (
        <div>
            <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isAuthenticationDialogOpen} onClose={loginStore.setDialogClose}>
                <Box sx={{ display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600vw', height: '7vh', }}>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
                        <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                            <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                            <WhiteTextTypography variant={isMobile ? "subtitle1" : "h5"}> {Guide_clover_dialog_AuthenticationCheck_01}</WhiteTextTypography>
                        </Grid>
                        <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("AuthenticationFalse") }} />
                        </Grid>
                    </Grid>
                </Box>
                <DialogContent >
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} whiteSpace='pre-wrap' direction="column" justifyContent='center' alignItems='center' >
                        <Typography >
                            {Guide_clover_dialog_AuthenticationCheck_02}
                        </Typography>
                        {/* <Typography>
                            본인 인증을 위한 개인정보 수집 · 이용 및 제공, 위탁 동의서
                        </Typography>
                        <Typography>
                            개인정보 보호법에 따라 (주)SoftBrain에 인증을 요청하시는 분께
                        </Typography>
                        <Typography>
                            수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간, 동의 거부권 및 동의 거부 시
                        </Typography>
                        <Typography>
                            불이익에 관한 사항을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다.
                        </Typography>
                        <Typography>
                            1. 개인정보의 수집 및 이용목적
                        </Typography>
                        <Typography>
                            서비스 이용시 이용자로부터 수집하는 개인정보는 아래와 같습니다.
                        </Typography>
                        <Typography>
                            -회원정보 또는 개별 서비스에서 프로필 정보 ( 닉네임, 프로필 사진 )를 설정할 수 있습니다.
                        </Typography>
                        <Typography>
                            2. 수집하려는 개인정보의 항목
                        </Typography>
                        <Typography>
                            -인증 요청 시에 '휴대전화번호,이메일 주소'를 필수항목으로 수집합니다.
                        </Typography>
                        <Typography>
                            3.개인정보의 보유 및 이용기간
                        </Typography>
                        <Typography>
                            - 부정 가입 및 이용 방지
                        </Typography>
                        <Typography>
                            탈퇴한 이용자의 휴대전화번호 : 탈퇴일로부터 6개월 보관
                        </Typography>
                        <Typography>
                            4. 개인정보 수집 및 이용 동의를 거부할 권리
                        </Typography>
                        <Typography>
                            이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다.
                        </Typography>
                        <Typography>
                            회원가입 시 수집하는 최소한의 개인정보, 즉, 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우, 인증 요청이 어려울 수 있습니다.
                        </Typography> */}
                        <Grid container justifyContent="center" alignItems="center">
                            <Checkbox checked={VerifyShareBool} onChange={(e) => { UserProfileStore.setPersonalInformationConsentCheck(e.target.checked) }} onClick={(e) => { UserProfileStore.setVerifyCheck("good") }} />
                            <Box onClick={(e) => { UserProfileStore.setVerifyCheck("good") }} >
                                {Guide_clover_allPage_04}
                            </Box>
                        </Grid>
                        {/* <FormControlLabel control={<Checkbox defaultChecked={VerifyShareBool} onChange={(e) => { UserProfileStore.setPersonalInformationConsentCheck(e.target.checked) }} />} onClick={(e) => { UserProfileStore.setVerifyCheck("good") }} label="개인정보 수집 이용 동의" /> */}
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    );
};


export default observer(AuthenticationCheck);